import { BaseService } from './base.service';

export interface BannerDto {
  id: string;
  type: 'image+text' | 'text-only';
  headline?: string;
  body?: string;
  ctaLabel?: string;
  ctaUrl?: string;
  imageUrl?: string;
  imageSignedUrl?: string;
  priority: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

class BannerServiceClass extends BaseService {
  constructor() {
    super('/banners');
  }

  getActiveBanners(locationId?: string, franchiseId?: string): Promise<BannerDto[]> {
    const params = new URLSearchParams();
    if (locationId) params.set('locationId', locationId);
    if (franchiseId) params.set('franchiseId', franchiseId);
    const query = params.toString();
    return this.get<BannerDto[]>(query ? `/active?${query}` : '/active');
  }
}

export const BannerService = new BannerServiceClass();
